import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppConfig from "../../../../AppConfig";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  heading: {
    margin: "1rem 0rem 1rem 0rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    color: "#714865",
    fontWeight: "700",
    fontSize: "1.75rem",
    lineHeight: "2.1rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
    textAlign: "center",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  illustrationSizer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "200px",
      width: "250px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "200px",
      width: "300px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "220px",
      width: "340px",
    },
    [theme.breakpoints.only("md")]: {
      height: "224px",
      width: "380px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "224px",
      width: "380px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "224px",
      width: "380px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "480px",
      width: "768px",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      height: "480px",
      width: "768px",
    },
  },
}));

const SectionOne = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.text}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={224}
          width={380}
          src="/images/illustrations/under-construction/legendarybeginnings.png"
          className={classes.illustrationSizer}
        />
        <Typography variant="h1" component="h1" className={classes.heading}>
          COMING SOON
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default SectionOne;
